import { LoadingOutlined } from '@ant-design/icons';
import { ContainerLoading } from './styles';

interface ILoadingProps {
  load: boolean;
}

export const Loading: React.FC<ILoadingProps> = ({ load }) => {
  if (!load) return <></>;

  return (
    <ContainerLoading>
      <LoadingOutlined
        style={{ color: 'var(--sigeclin-primary)', fontSize: 50 }}
      />
    </ContainerLoading>
  );
};
